// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","SearchResults":"jc_a bhc_a bhc_j bhc_q bhc_rp bhc_rq bhc_w"};